import { EColors } from "libs/style/styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  children: React.ReactNode
}

export const H1 = (props: Props): JSX.Element => {
  return <S_H1>{props.children}</S_H1>
}

export const S_H1 = styled.h1`
  color: ${EColors.WHITE};
  font-family: "InterBold";
  font-size: 29px;
  line-height: 41px;
  letter-spacing: -0.03em;
  @media only screen and (min-width: 1260px) {
    font-size: 42px;
    line-height: 60px;
  }
`
